export type Tome = {
  label: string;
  emoji: string;
  title: string;
  subtitle: string;
  accent: 'blue' | 'green' | 'gold';
  cover: string;
  coverAlt: string;
  features: string[];
};

export type Bonus = {
  number: string;
  title: string;
  pages: string;
  description: string;
  cover: string;
  coverAlt: string;
};

/** Los 3 tomos principales del Kit Maestro. */
export const tomes: Tome[] = [
  {
    label: 'TOMO I',
    emoji: '📘',
    title: 'Blindaje Legal 360°',
    subtitle: 'Marco legal, documentos y protocolos de derivación para trabajar con confianza',
    accent: 'blue',
    cover: 'https://cdn.magicpatterns.com/uploads/oE5jFxLc2rreviCtEDD59t/tomo_1.png',
    coverAlt: 'Portada del Tomo I: Blindaje Legal 360°',
    features: [
      'Marco legal argentino: curación vs acompañamiento (diferencia crítica)',
      'Qué es el intrusismo médico y cómo evitarlo legalmente',
      'Consentimiento informado: qué debe incluir, paso a paso',
      '4 documentos editables listos para firmar (Consentimiento, Deslinde, Confidencialidad, Protocolo de Derivación)',
      'Cómo comunicar con pacientes sin que parezca medicina',
      'Protocolo de derivación ética: cuándo y cómo hacerlo',
      'FAQ legal: respuestas a preguntas difíciles',
      '50 páginas de documentación, criterios y recursos para trabajar con mayor claridad dentro de tu alcance profesional',
    ],
  },
  {
    label: 'TOMO II',
    emoji: '📗',
    title: 'Protocolos de Bioshock y Anamnesis Express',
    subtitle: 'Preguntas de exploración y recursos visuales para organizar la información del consultante',
    accent: 'green',
    cover: 'https://cdn.magicpatterns.com/uploads/t6h4wEDRCo3RGfGDQxVwbu/Screenshot_20260908-205643~2.jpg',
    coverAlt: 'Portada del Tomo II: Protocolos de Bioshock y Anamnesis Express',
    features: [
      'Fundamentos del enfoque Bioshock explicados de manera práctica',
      'Sistema nervioso autónomo: conceptos fundamentales para el terapeuta',
      '7 preguntas para ordenar la exploración del contexto emocional',
      'Mapa visual del cuerpo como recurso de consulta y exploración',
      'Árbol genealógico flash para organizar antecedentes familiares',
      'Identificación de acontecimientos y patrones repetidos en la historia personal',
      'Scripts de sesión: preguntas y frases orientativas para cada etapa',
      'Casos prácticos con ejemplos de aplicación',
      '50 páginas de herramientas organizadas para consulta rápida',
    ],
  },
  {
    label: 'TOMO III',
    emoji: '📕',
    title: 'Prácticas Simbólicas de Integración',
    subtitle:
      '15 ejercicios simbólicos y recursos de cierre para acompañar procesos de reflexión e integración',
    accent: 'gold',
    cover: 'https://cdn.magicpatterns.com/uploads/cATMsnKzgCLq5KMaYi6CB8/Screenshot_20260908-205730~2.jpg',
    coverAlt: 'Portada del Tomo III: Prácticas Simbólicas de Integración',
    features: [
      'Fundamentos del trabajo simbólico aplicado al acompañamiento',
      'Cómo utilizar símbolos como recursos de reflexión personal',
      '15 prácticas guiadas de escritura, visualización, movimiento y cierre',
      'Cómo seleccionar una práctica según el objetivo de la sesión',
      'Ejercicios de escritura reflexiva y visualización guiada',
      'Recursos de respiración, regulación y autocompasión',
      'Indicadores para realizar seguimiento después de la práctica',
      '50 páginas de ejercicios y recursos listos para consultar',
    ],
  },
];

/** Los 5 bonus estratégicos, siempre incluidos. */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'El Cuaderno del Paciente',
    pages: '25 páginas',
    description:
      'Herramienta previa a la sesión para organizar historia personal, antecedentes familiares, acontecimientos relevantes y motivo de consulta',
    cover: 'https://cdn.magicpatterns.com/uploads/5finiQZ4aqkPnvg1Kw64F5/1.png',
    coverAlt: 'Portada del Bonus 01: El Cuaderno del Paciente',
  },
  {
    number: '02',
    title: 'Bitácora de 21 Días',
    pages: '25 páginas',
    description:
      'Registro post-sesión para acompañar durante 21 días observaciones, emociones, hábitos y cambios percibidos',
    cover: 'https://cdn.magicpatterns.com/uploads/q6UweopNBgyHAyVsGaT7PZ/ChatGPT_Image_7_sept_2026,_18_01_29.png',
    coverAlt: 'Portada del Bonus 02: Bitácora de 21 Días de Vagotonía',
  },
  {
    number: '03',
    title: 'Radar de Preguntas Gatillo™',
    pages: '20 páginas',
    description:
      '50 preguntas organizadas por sistemas y áreas de exploración para profundizar la conversación sin quedarte en blanco',
    cover: 'https://cdn.magicpatterns.com/uploads/tBkt9j9YAkJNCJNn4Vb4f3/1.png',
    coverAlt: 'Portada del Bonus 03: Radar de Preguntas Gatillo',
  },
  {
    number: '04',
    title: 'Guía de Comunicación Ética Meta Ads',
    pages: '15 páginas',
    description:
      'Cómo vender tus servicios en Facebook/Instagram sin violar políticas ni perder cuenta publicitaria',
    cover: 'https://cdn.magicpatterns.com/uploads/q34MrRM3qQUZe6QLCwFoRE/ChatGPT_Image_8_sept_2026,_11_13_55.png',
    coverAlt: 'Portada del Bonus 04: Guía de Comunicación Ética Meta Ads',
  },
  {
    number: '05',
    title: 'Lista de Chequeo Filtro Rojo',
    pages: '10 páginas',
    description:
      'Guía de señales de alerta y criterios para reconocer cuándo detener el acompañamiento y recomendar atención profesional',
    cover: 'https://cdn.magicpatterns.com/uploads/pdXLmdsTtqiCj347SWauxt/ChatGPT_Image_8_sept_2026,_11_48_27.png',
    coverAlt: 'Portada del Bonus 05: Lista de Chequeo Filtro Rojo',
  },
];
